<template>
  <section id="mop-popup" class="slideDown">
    <div class="title">
      {{ $t('admin.mop.popup.title') }}
    </div>

    <div class="col">
      <span class="label">{{ $t('admin.mop.popup.start_date') }}</span>
      <input
        class="start date"
        type="datetime-local"
        step="60000"
        v-model="start_date"
      />
    </div>
    <div class="col">
      <span class="label">{{ $t('admin.mop.popup.end_date') }}</span>
      <input
        class="end date"
        type="datetime-local"
        step="60000"
        v-model="end_date"
      />
    </div>
    <div class="col">
      <span class="label">{{ $t('admin.mop.popup.reason') }}</span>
      <textarea class="value" type="text" v-model="value"></textarea>
      <span class="description">{{ $t('admin.mop.popup.description') }}</span>
    </div>

    <div v-if="errors" class="errors">{{ errors }}</div>

    <div class="buttons">
      <div class="button cancel" @click="cancel()">{{ $t('general.cancel') }}</div>
      <div class="button confirm" @click="validate()">{{ $t('general.confirm') }}</div>
    </div>
  </section>
</template>

<script>
import i18n from "@/i18n";

export default {
  props: { mop: Object },
  data() {
    return {
      start_date: false,
      end_date: false,
      value: "",
      errors: false
    };
  },
  created() {},
  computed: {},
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    validate() {
      this.errors = false;

      if (!this.start_date) {
        this.errors = i18n.t('admin.mop.popup.start_date_error');
      }
      if (!this.errors && new Date(this.start_date) <= new Date()) {
        this.errors = i18n.t('admin.mop.popup.start_date_error_past');
      }
      if (!this.errors && !this.end_date) {
        this.errors = i18n.t('admin.mop.popup.end_date_error');
      }
      if (!this.errors && new Date(this.start_date) > new Date(this.end_date)) {
        this.errors = i18n.t('admin.mop.popup.end_date_error_past');
      }
      if (!this.errors && this.value.trim().length < 50) {
        this.errors = i18n.t('admin.mop.popup.description_error');
      }

      if (!this.errors) {
        var params = {
          start_date: this.start_date,
          end_date: this.end_date,
          value: this.value,
          status: JSON.parse(localStorage.getItem('confirm') || 'false') ? 2 : 1
        };

        this.$emit("add", params);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#mop-popup {
  background-color: #fff;
  position: fixed;
  width: 700px;
  height: 450px;
  left: calc(50% - 350px);
  top: calc(50% - 225px);
  border-radius: 4px;
  z-index: 20;
  padding: 20px;

  .title {
    margin-bottom: 25px;
  }

  .col {
    width: 500px;
    margin: 0 auto;
    margin-bottom: 10px;
    .label {
      width: 100%;
      display: block;
      text-align: left;
    }
    .description {
      width: 100%;
      display: block;
      text-align: left;
      font-size: 85%;
      color: #666;
    }
    input,
    textarea {
      border: 1px solid #ccc;
      padding: 8px;
      border-radius: 4px;
      width: 100%;
    }
  }
  .errors {
    color: #d42525;
    border: 2px solid #d42525;
    background-color: transparent;
    padding: 8px;
    border-radius: 4px;
    width: 500px;
    margin: 20px auto;
  }

  .buttons {
    width: 500px;
    display: flex;
    margin: 0 auto;
    flex-wrap: nowrap;
    align-content: space-around;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 10px;

    .button {
      display: inline-block;
      cursor: pointer;
      padding: 8px;
      border-radius: 4px;
      background-color: #ccc;
      width: 100%;

      &.confirm {
        background-color: var(--main_color);
      }
    }
  }
}
</style>
